const FALLBACK_COLOR = "#1B2A6B";

export function buildCityRegionMap(cities) {
  return cities.reduce((map, city) => {
    if (city.city_name && city.region_id) {
      map[city.city_name.trim().toLowerCase()] = {
        id: city.region_id,
        name: city.region_name || "Region",
        color: /^#[0-9A-Fa-f]{6}$/.test(city.region_color_code)
          ? city.region_color_code.toUpperCase()
          : FALLBACK_COLOR,
      };
    }
    return map;
  }, {});
}

export function regionForItem(regionMap, item) {
  const cityName = item?.moving_from?.trim().toLowerCase();
  return cityName ? regionMap[cityName] || null : null;
}

export function regionChipStyle(region) {
  if (!region) return undefined;
  return {
    backgroundColor: `${region.color}1A`,
    borderLeft: `3px solid ${region.color}`,
    color: "#0F172A",
  };
}
